<script>
export default {
  name: 'BaseCoverContainer',
  props: {
    isPlaying: {
      type: Boolean,
      required: true,
    },
    dispatch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      width: undefined,
      height: undefined,
    }
  },

  computed: {
    adhere() {
      return {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
      }
    },
    scale() {
      const aspect = this.width / this.height
      const targetAspect = 16 / 9
      const scale = (aspect / targetAspect) > 1
        ? (aspect / targetAspect) * 1.10
        : (targetAspect / aspect) * 1.10
      return {
        ...this.adhere,
        transform: `scale(${scale})`,
      }
    },
  },

  // hooks
  mounted() {
    this.handleResize()
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize() {
      const { width, height } = this.$el.getBoundingClientRect()
      this.width = width
      this.height = height
    },
  },

  render(createElement) {
    const { dispatch, scale, isPlaying } = this

    if (isPlaying) {
      const { children } = this.$el
      Object.keys(children).forEach((vnode) => {
        const node = children[vnode]
        if (node.tagName === 'IFRAME') {
          node.setAttribute('tabindex', -1)
        }
      })
    }

    const slotData = dispatch
      ? this.$scopedSlots.default({ scale: this.scale })
      : this.$slots.default

    const { name } = this.$options
    const elementData = {
      staticClass: name,
      style: !!dispatch || scale,
      class: `${name}--${isPlaying ? 'isPlaying' : 'isLoading'}`,
    }
    return createElement('div', elementData, slotData)
  },
}
</script>

<style lang="scss">
.BaseCoverContainer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  iframe {
    // width: 100%;
    // max-width: 100%;
    // height: 100%;
    // max-height: 100%;
    // position: absolute;
    // width: 100vw;
    // height: 56.25vw;
    // min-height: 100vh;
    // min-width: 177.77vh;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%,-50%);
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/js/components/BaseCoverContainer.vue